query getCurrentOnboardingStep {
  getCurrentOnboardingStep {
    name
  }
}
